import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ChatRoomsState, ChatRoomsStore } from './chat-rooms.store';

@Injectable({
  providedIn: 'root',
})
export class ChatRoomsQuery extends QueryEntity<ChatRoomsState> {
  constructor(protected store: ChatRoomsStore) {
    super(store);
  }
}
